import './Dashboard.scss'
import {useEffect, useState} from "react";
import {getMensagens} from "../../services/mensagemService";
import {getGrupos} from "../../services/grupoService";

export default function Dashboard() {
    const [grupos, setGrupos] = useState<any[]>([])

    useEffect(() => {
        const listGruposReq = async () => {
            const req: any = await getGrupos();
            setGrupos(req.payload)
            // setLoading(false);
        }
        listGruposReq();
    }, [])

    return (
        <div className={"dashboard"}>
            <div className={"header mb-4"}>
                <h2>
                    Dashboard
                </h2>
            </div>
            <div className={"content"}>
                <div className={"mb-2"}>
                    <button>➕ Adicionar mensagem</button>
                </div>
                <div className={"container-grupo"}>
                    <div>
                        <h4>Grupos</h4>
                    </div>
                    <div className={"grupos container"}>
                        <div className={"row"}>
                            <div className={"col-3 border rounded-1 shadow-sm p-2 d-flex flex-column justify-content-center align-items-center"}>
                                <div>Mensagens cadastradas</div>
                                <div>Sem grupo</div>
                            </div>
                            {grupos.map((grupo) => (
                                <div className={"col-3 border rounded-1 shadow-sm p-2"}>
                                    <h5>{grupo.titulo}</h5>
                                    <span>{grupo.descricao}</span>
                                </div>
                            ))}
                            <div className={"col-3 border rounded-1 shadow-sm p-2 d-flex flex-column justify-content-center align-items-center"}>
                                <div>Criar novo grupo</div>
                                <div style={{width: "50px", height: "50px"}} className={"border rounded-1 d-flex justify-content-center align-items-center"}>
                                    ➕
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

            </div>
        </div>
    )
}